import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from "react";

import ReactMarkdown from "react-markdown";
import classes from '../HeadingComponent.module.css';
import rehypeRaw from 'rehype-raw'
import { useParams } from "react-router-dom";

// temp for testing . . .
const markdownText = `
# React Markdown Example
- Some text
- Some other text
## Subtitle tww
### Additional info
This is a [link](https://github.com/remarkjs/react-markdown)
`;

function CollectionContent() {
	const { filename } = useParams();
	const [markdownContent, setMarkdownContent] = useState("");

	useEffect(() => {
		fetch(`/collections/${filename}.md`)
			.then((response) => response.text())
			.then((text) => setMarkdownContent(text));
	}, [filename]);

	// text-nowrap
	return (
		<Container fluid className={classes.container}>
			<div class="text-nowrap">
				<div className={classes.headingCardMarkdown}></div>
				<Container>
					<ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownContent}</ReactMarkdown>
				</Container>
			</div>
		</Container>
		);
	}

export default CollectionContent;